<template>
  <div class="">
    <div id="components-form-demo-advanced-search">
      <a-form
              class="ant-advanced-search-form"
              :form="form"
              @submit="handleSearch"
      >
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="采集点名称：">
              <a-input
                      v-model="param.name"
                      placeholder="请输入采集点名称进行查询"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="采集点编码：">
              <a-input
                      v-model="param.code"
                      placeholder="请输入采集点编码进行查询"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" :style="{ textAlign: 'right' }">
            <a-button type="primary" html-type="submit">
              查询
            </a-button>
            <a-button :style="{ marginLeft: '8px' }" @click="handleReset">
              清除
            </a-button>
            <a-button :style="{ marginLeft: '8px' }" type="primary" @click="toCreate()">
              新建
            </a-button>
          </a-col>
        </a-row>
      </a-form>
      <!-- 表格 -->
      <div class="table">

        <a-table
                :columns="columns"
                :dataSource="dataList"
                :pagination="pagination"
                rowKey="id"
                @change="TableChange"
        >
          <template slot="serial" slot-scope="text, record, index">
            <template>
              {{ ((pagination.current - 1)*pagination.pageSize) + (index+1) }}
            </template>
          </template>

          <span slot="status" slot-scope="text,record">
            <a-switch slot="status" :default-checked="record.status == 1" @change="onChangeStatus($event,record)"/>
          </span>

          <template slot="opera" slot-scope="text,record">
            <a-tag slot="opera" color="green" @click="toEdit(record)"  style="cursor: pointer;">
              编辑
            </a-tag>
            <a-tag slot="opera" color="volcano" @click="deleteData(record)"  style="cursor: pointer;">
              删除
            </a-tag>
          </template>
        </a-table>


      </div>
    </div>
    <!-- 删除弹框 -->
    <div>
      <a-modal
              title="提示"
              :visible="visible"
              :confirm-loading="confirmLoading"
              @ok="handleOk"
              @cancel="handleCancel"
              ok-text="确认"
              cancel-text="取消"
      >
        <p>{{ ModalText }}</p>
      </a-modal>
    </div>
  </div>
</template>
<script>


const columns = [
  {
    title: "序号 ",
    dataIndex: "serial",
    key: "serial",
    scopedSlots: { customRender: 'serial' }
  },
  {
    title: "采样点名称 ",
    dataIndex: "name",
    key: "name"
  },
  {
    title: "采样点编码 ",
    dataIndex: "code",
    key: "code"
  },
  {
    title: "状态 ",
    key: "status",
    dataIndex: "status",
    scopedSlots: { customRender: "status" }
  },
  {
    title: "操作 ",
    key: "opera",
    dataIndex: "opera",
    scopedSlots: { customRender: "opera" }
  }
];

const dataList = [

];
import { demoList, deleteDemo,updateDemo } from "@/api/demo/demo";

export default {
  data() {
    return {
      form: this.$form.createForm(this, {
        name: "" ,
      }),

      optionAreas: [
        {
          value: '1',
          label: '北京市'
        }
      ],
      showSearch: {
        filter: (inputValue, path) => {
          return path.some(option => {
                    // label搜索
                    return fullText(inputValue, option.label);
                  }
          )
        },
        matchInputWidth: true
      },

      param:{
        size: 10,
        page: 1,
        code: "",
        name: ""
      },

      dataList,
      columns,

      pagination: {
        current: 1,
        pageNo: 1,
        pageSize: 10, // 默认每页显示数量
        showSizeChanger: true, // 显示可改变每页数量
        pageSizeOptions: ['10', '20', '30'], // 每页数量选项
        showTotal: total => `共有 ${total} 条`, // 显示总数
        //onChange: (page, pageSize) => this.changePage(page, pageSize), // 点击页码事件
        total: 0 // 总条数
      },


      ModalText: "确定要删除该信息吗？",
      visible: false,
      confirmLoading: false,

    };
  },
  computed: {},
  filters: {
    statusFilter (status) {
      if(status === 0)
        return "禁用"
      else if(status === 1)
        return "启用"
      else
        return "启用"
    }
  },
  created() {
    this.getList({});

  },
  updated() {
    console.log("updated");
  },
  methods: {
    getList(number) {

      if (number === 0) {
        this.pagination.current = 1
        this.param.page = 1
      }
      demoList(this.param).then(response => {

        this.dataList = response.data.list
        if (this.dataList) {
          this.pagination.total = response.data.total
        }
      });
    },

    // 搜索
    handleSearch(e) {
      e.preventDefault();
      this.form.validateFields((error, values) => {
        console.log("error", error);
        console.log("Received values of form: ", values);
      });
      this.getList(0);
    },
    TableChange (e) {
      // 每页数量变更
      this.pagination.current = e.current
      this.param.page = e.current
      this.param.size = e.pageSize
      this.getList()
    },
    changePage (page, pageSize) {
      // 页码变更
      this.pagination.current = page
      this.param.page = page
      this.param.size = pageSize
      this.getList()
    },
    //清除
    handleReset() {
      this.form.resetFields();

      this.getList();
    },
    //打开删除弹框
    deleteData(value) {
      console.log(value);
      this.id = value.id;
      this.visible = true;
    },
    //确定删除
    handleOk() {
      this.visible = false;
      let _this = this;
      deleteDemo({
        demoId: _this.id
      })
              .then(res => {
                console.log(res);
                if (res.code == 0) {
                  _this.$message.success("删除成功", function() {
                    _this.getList();
                  });
                } else {
                  _this.$message.error(res.message);
                }
              })
              .catch(err => {
                _this.$message.error(err.message);
              });
    },
    //取消删除
    handleCancel() {
      this.visible = false;
    },
    //新建/编辑/查看
    toCreate() {
      this.$router.push({
        path: "/index/auth/democreate"
      });
    }, //新建/编辑/查看
    toEdit(value) {
      this.id = value.id;
      this.$router.push({
        path: "/index/auth/democreate",
        query: {
          id: this.id
        }
      });
    },
    onChangeStatus(e,p) {

      let status = e ? 1 : 0;
      let _this = this;
      updateDemo({
        id:p.id,
        status: status
      }).then(res => {
        if(res.code == 0) {
          _this.$message.success('状态更新成功', function () {
            // _this.getList();
          })
        } else {
          _this.$message.error('状态更新失败');
        }
      })
    },
  }
};
</script>
<style scoped>
  .ant-advanced-search-form {
    padding: 24px;
    background: #ffffff;
    /* border: 1px solid #d9d9d9; */
    /* border-radius: 6px; */
  }

  .ant-advanced-search-form .ant-form-item {
    display: flex;
  }

  .ant-advanced-search-form .ant-form-item-control-wrapper {
    flex: 1;
  }

  #components-form-demo-advanced-search .ant-form {
    max-width: none;
  }
  #components-form-demo-advanced-search .search-result-list {
    margin-top: 16px;
    border: 1px dashed #e9e9e9;
    border-radius: 6px;
    background-color: #ffffff;
    min-height: 200px;
    text-align: center;
    padding-top: 80px;
  }
  .table {
    margin-top: 20px;
    background: #ffffff;
    padding: 20px;
  }
</style>
